/* eslint-disable no-underscore-dangle */
import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getThongTinHocPhiLop(payload: {
  page: number;
  limit: number;
  cond?: any;
  lopId?: string;
}) {
  const { page, limit, cond, lopId } = payload;
  return axios.get(`${ip3}/con/pageable/lop/${lopId}`, {
    params: {
      page,
      limit,
      donViId: lopId,
      cond: {
        ...cond,
      },
    },
  });
}

export async function getThongTinHocPhiLopNew(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
  thang?: number;
  nam?: number;
}) {
  const { page, limit, cond, donViId, thang, nam } = payload;
  return axios.get(`${ip3}/con/pageable/phu-phi/lop/${donViId}`, {
    params: {
      page,
      limit,
      donViId: donViId,
      cond: {
        ...cond,
        thang,
        nam,
      },
    },
  });
}

export async function getThongTinHocPhi(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
  thang?: number;
  nam?: number;
}) {
  const { page, limit, cond, donViId, thang, nam } = payload;
  return axios.get(`${ip3}/thong-tin-hoc-phi/pageable`, {
    params: {
      page,
      limit,
      cond: {
        ...cond,
        donViId,
        thang,
        nam,
      },
    },
  });
}

export async function getThongTinHocPhiLopPageable(payload: {
  page: number;
  limit: number;
  cond?: any;
}) {
  const { page, limit, cond } = payload;
  return axios.get(`${ip3}/thong-tin-hoc-phi-lop/pageable`, {
    params: {
      page,
      limit,
      cond: {
        ...cond,
      },
    },
  });
}

export async function getThongTinChiTiet(payload: {
  page: number;
  limit: number;
  cond?: any;
  lopId?: string;
}) {
  const { page, limit, cond, lopId } = payload;
  return axios.get(`${ip3}/hoc-phi/pageable`, {
    params: {
      page,
      limit,
      donViId: lopId,
      cond: {
        ...cond,
      },
    },
  });
}

export async function getThongTinHocPhiTruong(payload: {
  page: number;
  limit: number;
  cond?: any;
  lopId?: string;
}) {
  const { page, limit, cond } = payload;
  let cond2: any
  const newCond = { ...cond };
  if (newCond["con.hoTen"]) {
    cond2 = {
      regex: newCond["con.hoTen"]["$regex"],
      options: newCond["con.hoTen"]["$options"]
    }
    delete newCond["con.hoTen"]
  }
  return axios.get(`${ip3}/hoc-phi/hieu-truong/thang/${newCond?.thang}/nam/${newCond?.nam}`, {
    params: {
      page,
      limit,
      cond1: {
        trangThaiThanhToan: newCond.trangThaiThanhToan,
        donViId: newCond.donViId
      },
      cond2: {
        ...cond2
      }
    }
  })
}

export async function addThongTinHocPhi(payload: any) {
  return axios.post(`${ip3}/thong-tin-hoc-phi`, payload);
}

export async function addThongTinHocPhiLop(payload: any) {
  return axios.post(`${ip3}/thong-tin-hoc-phi-lop`, payload);
}

export async function updTrangThaiThanhToan(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/hoc-phi/${id}`, payload);
}
export async function updThongTinHocPhiCon(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi/${id}`, payload);
}
export async function updThongTinHocPhiLop(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi-lop/${id}`, payload);
}
export async function updDuyetHienThiHocPhi(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi-lop/${id}/duyet-hien-thi-hoc-phi`, payload);
}
export async function updDuyetHienThiHocPhiAll(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi-truong/truong/${id}/duyet-hien-thi-hoc-phi`, payload);
}
export async function updThongTinPhuPhiLop(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/thong-tin-hoc-phi-lop/phu-phi/${id}`, payload);
}
export async function addHocThuBay(payload: {
  conId: string,
  donViId: string,
  thang: number,
  nam: number
}) {
  const { conId, donViId, thang, nam } = payload;
  return axios.post(`${ip3}/thong-tin-hoc-phi/dang-ky-hoc-thu-7`, {
    conId,
    donViId,
    thang,
    nam
  });
}
export async function delHocThuBay(payload: {
  conId: string,
  donViId: string,
  thang: number,
  nam: number
}) {
  const { conId, donViId, thang, nam } = payload;
  return axios.delete(`${ip3}/thong-tin-hoc-phi/dang-ky-hoc-thu-7/con/${conId}/lop/${donViId}/thang/${thang}/nam/${nam}`);
}
export async function delThongTinHocPhi(payload: { id: string }) {
  const { id } = payload;
  return axios.delete(`${ip3}/hoc-phi/${id}`);
}


export async function postVerifyOtpBank(payload: any) {
  return axios.post(`${ip3}/hoc-phi/verify-otp-bank`, payload);
}

export async function reSendOtpBank(id: string) {
  return axios.get(`${ip3}/hoc-phi/tai-khoan/${id}/resend-otp-bank`);
}

export async function delAccountBank(payload: any ) {
  return axios.post(`${ip3}/hoc-phi/delete/tai-khoan-hoc-phi`, payload);
}
